__turbopack_context__.v({
  "backdrop": "index-module-scss-module__RtJEQa__backdrop",
  "body": "index-module-scss-module__RtJEQa__body",
  "close_button": "index-module-scss-module__RtJEQa__close_button",
  "container": "index-module-scss-module__RtJEQa__container",
  "header": "index-module-scss-module__RtJEQa__header",
  "is_hidden": "index-module-scss-module__RtJEQa__is_hidden",
  "sentinel_bottom": "index-module-scss-module__RtJEQa__sentinel_bottom",
  "sentinel_top": "index-module-scss-module__RtJEQa__sentinel_top",
  "sliding-backdrop-in": "index-module-scss-module__RtJEQa__sliding-backdrop-in",
  "sliding-backdrop-out": "index-module-scss-module__RtJEQa__sliding-backdrop-out",
  "sliding-in": "index-module-scss-module__RtJEQa__sliding-in",
  "sliding-out": "index-module-scss-module__RtJEQa__sliding-out",
  "wrapper": "index-module-scss-module__RtJEQa__wrapper",
});
